// extracted by mini-css-extract-plugin
export default {"wrapper":"cB-z","button":"dB-z","alternate":"eB-z","disabled":"fB-z","paymentWarning":"gB-z","fadeIn":"hB-z"};